import { getPosts } from '@/API/repositories/lms';
import { getNotDeliveredPackages } from '@/API/repositories/reports';
import { getToday } from '@/common/functions/getToday';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useState, useRef, useEffect } from 'react';

const useNotDeliveredPackagesReport = () => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const [data, setData] = useState(null);
	const {
		options: { marketsOptions },
	} = useCommonDataContext();
	const [selectedMarkets, setSelectedMarkets] = useState([]);
	const [selectedShippingProvider, setSelectedShippingProvider] = useState();
	const [couriers, setCouriers] = useState([]);
	const { addMessage } = useMessageQueueContext();

	const dateFromRef = useRef();
	const dateToRef = useRef();
	const today = getToday();

	const handleSearch = async (e) => {
		e?.preventDefault();

		setData(() => null);

		if (
			!dateFromRef.current.value ||
			!dateToRef.current.value ||
			selectedMarkets?.length === 0
		) {
			addMessage('Fill all fields');
			return;
		}
		const marketsIds = selectedMarkets.map((queue) => queue.value);
		const payload = {};
		payload.markets = marketsIds;
		payload.from = new Date(dateFromRef.current.value).toISOString();
		payload.to = new Date(dateToRef.current.value).toISOString();

		const couriersToCheck = couriers.filter((c) =>
			selectedShippingProvider.map((s) => s.value).includes(c.provider),
		);

		payload.couriers = [
			...couriersToCheck.map((c) => c._id),
			...couriersToCheck.map((c) => c.curier_name),
		];

		const response = await makeRequest(
			getNotDeliveredPackages.bind(null, payload),
		);

		setData(() => response.data || []);
	};

	const loadCouriers = async () => {
		const response = await makeRequest(getPosts.bind(null));
		setCouriers(() => response.data);
	};

	useEffect(() => {
		loadCouriers();
	}, []);

	const isLoading = hasUnfilledRequest(getNotDeliveredPackages);

	return {
		data,
		handleSearch,
		isLoading,
		marketsOptions,
		selectedMarkets,
		setSelectedMarkets,
		dateFromRef,
		dateToRef,
		today,
		setSelectedShippingProvider,
		selectedShippingProvider,
		couriers,
	};
};

export default useNotDeliveredPackagesReport;
